import { RouteRecordRaw } from 'vue-router';
import { ApprovalListPage } from '@/pages/approval';

export const routeName = 'Approvals';

export const route: RouteRecordRaw = {
  path: 'aprovacao',
  name: routeName,
  component: ApprovalListPage,
  meta: {
    requiresAuth: true,
    breadcrumb: 'Etapa de Análise Crítica e Aprovação',
    permissions: [
      { action: 'manageApproval', subject: 'Homologation' },
      { action: 'manageVerification', subject: 'Homologation' },
    ],
    matchMode: 'any',
  },
};
